// placeholder for the index file, add the export statements here
import React from 'react';

export * from './types';

export const PaymentCards = React.lazy(() => import('./cards'));
export const PaymentCardsWallet = React.lazy(() => import('./wallet'));
export const PaymentCardTransactions = React.lazy(() => import('./transactions'));
export const PaymentCardsCompany = React.lazy(() => import('./company'));
export const PaymentCardsAuth = React.lazy(() => import('./auth'));
export const PaymentCardsOnboardingPage = React.lazy(() => import('./onboarding'));
export const PaymentCardsSysPageModal = React.lazy(() => import('./common/SysPage'));
export const PaymentCardsOnboardingDialog = React.lazy(() => import('./common/OnboardingDialog'));
export const PaymentCardsOffboardingDialog = React.lazy(() => import('./common/OffboardingDialog'));
